import { render, staticRenderFns } from "./validation-panier.vue?vue&type=template&id=bb3f0a8e&scoped=true&"
import script from "./validation-panier.vue?vue&type=script&lang=js&"
export * from "./validation-panier.vue?vue&type=script&lang=js&"
import style0 from "./validation-panier.vue?vue&type=style&index=0&id=bb3f0a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3f0a8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
